import { AxiosRequestConfig } from "axios";
import { permissionsApi } from "@iventis/api/src/api";
import { translate } from "@iventis/translations/translation";
import { Content } from "@iventis/translations";

export const forgotPassword = async (email: string) => {
    await permissionsApi.post<{ email: string }>(
        `authentication/local_password/token`,
        { email },
        {
            customErrorMessage: {
                title: translate(Content.errors.custom_network_error.generic.title, { action: translate(Content.login.buttons.sendLink)?.toLocaleLowerCase?.() }),
                message: translate(Content.errors.custom_network_error.generic.message, { action: translate(Content.login.buttons.sendLink) }),
            },
        }
    );
};

export const setLocalPassword = async (accessKey: string, secretAccessKey: string, password: string) => {
    const config: AxiosRequestConfig = {
        headers: {
            "Access-Key": accessKey,
            "Secret-Access-Key": secretAccessKey,
        },
        suppressToasts: true,
    };
    await permissionsApi.post<{ newPassword: string }>(`authentication/local_password`, { password }, config);
};

/**
 * Determines if a set of access/secret keys can be used to set a password
 * @param {string} accessKey - Access key which was included in the set password email to the user as part of the link
 * @param {string} secretAccessKey - Secret access key which was included in the set password email to the user as part of the link
 * @param {AbortSignal} signal - Abort signal
 * @return {boolean} true if the link is valid, false if not
 */
export const localPasswordCanBeSet = async (accessKey: string, secretAccessKey: string, signal: AbortSignal) => {
    const config: AxiosRequestConfig = {
        headers: {
            "Access-Key": accessKey,
            "Secret-Access-Key": secretAccessKey,
        },
        signal,
        suppressErrors: true,
    };
    try {
        const response = await permissionsApi.post<boolean>(`authentication/local_password/validity`, null, config);
        return response.data;
    } catch {
        // If for any reason there was an error, the link likely had some other issues, ask the user to try forgotten password again
        return false;
    }
};
